import { createContext, useContext } from 'react'

import type { CoBranding } from './co-branding.ts'
import { defaultCoBranding } from './default-co-branding/index.ts'

type SetCoBranding = (coBranding: CoBranding | null) => void

const coBrandingContext = createContext<{ setCoBranding: SetCoBranding; coBranding: CoBranding | null }>({
  coBranding: null,
  setCoBranding: () => {},
})
export const CoBrandingContextProvider = coBrandingContext.Provider

/**
 * Setter for the active co-branding payload. Pass `null` to revert to the
 * default Orus assets.
 */
export function useSetCoBranding(): SetCoBranding {
  return useContext(coBrandingContext).setCoBranding
}

/**
 * Returns the active partner co-branding, falling back to the default Orus
 * payload when no partner has been set.
 */
export function useCoBranding(): CoBranding {
  return useContext(coBrandingContext).coBranding ?? defaultCoBranding
}

export function useActiveCoBranding(): CoBranding | null {
  return useContext(coBrandingContext).coBranding
}
